import { render, staticRenderFns } from "./fifththird.vue?vue&type=template&id=048aae83&scoped=true&"
import script from "./fifththird.vue?vue&type=script&lang=js&"
export * from "./fifththird.vue?vue&type=script&lang=js&"
import style0 from "./fifththird.vue?vue&type=style&index=0&id=048aae83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048aae83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048aae83')) {
      api.createRecord('048aae83', component.options)
    } else {
      api.reload('048aae83', component.options)
    }
    module.hot.accept("./fifththird.vue?vue&type=template&id=048aae83&scoped=true&", function () {
      api.rerender('048aae83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/fifth/fifththird.vue"
export default component.exports